import { makeStyles } from '@mui/styles';
import TextField from 'apollo-react/components/TextField';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';

import RuntimeTranslation from '../../../components/RuntimeTranslation';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import { getUITA } from '../../../utils/commonUtils';
import { showAsteriskBefore } from '../../utils/form-manager.utils';

const useStyles = makeStyles({
  requiredIcon: {
    '& label > span': { position: 'static !important' },
  },
  disabled: {
    '& .MuiInputBase-input.Mui-disabled': {
      border: '1px solid #d9d9d9 !important',
      backgroundColor: 'rgb(242, 242, 242) !important',
    },
  },
  fieldContainer: {
    display: 'flex',
    maxWidth: ({ isEditor }) => (isEditor ? 485 : null),
  },
});

const TextArea = ({
  label,
  actions,
  value = '',
  isRequired,
  className,
  error,
  isHiddenLabel,
  maxLength,
  instanceId,
  entityName,
  fieldName,
  isEditor,
  disabled,
}) => {
  const [newValue, setValue] = useState(value);
  const classes = useStyles({ isEditor });
  const translateString = useTranslation();

  //update inner state when `value` is changed from outside
  useEffect(() => {
    setValue(value);
  }, [value]);

  const onBlur = ({ target: { value: v } }) => {
    const _value = v.trim();
    setValue(_value);

    if (value !== _value) {
      actions.updateControlValue(_value);
    }
  };

  return (
    <div
      className={classes.fieldContainer}
      ui-ta={getUITA('FormCtrl', 'SSTextArea', entityName, fieldName)}
    >
      <TextField
        id={instanceId}
        label={isHiddenLabel ? '' : label}
        fullWidth
        asteriskPosition={showAsteriskBefore(label, false) ? 'before' : 'after'}
        multiline
        value={newValue ?? ''}
        className={classNames(className, classes.requiredIcon, isEditor && classes.disabled)}
        onBlur={onBlur}
        onChange={({ target: { value } }) => setValue(value)}
        required={isRequired}
        error={error}
        inputProps={{
          rows: 2,
          maxLength,
          style: {
            height: 'auto',
            overflow: 'auto',
            resize: 'both',
          },
          title: isRequired && !value ? translateString('Please fill out this field.') : '',
          'aria-label': translateString(label),
        }}
        disabled={isEditor || disabled}
        sizeAdjustable
        style={{ minWidth: 0 }}
      />
      <RuntimeTranslation value={newValue} />
    </div>
  );
};

export default TextArea;
